import { IsNotEmpty, IsString, Length, Matches } from 'class-validator';

export class ChallengeVerifyOtpRequestDto {
    @IsNotEmpty()
    @IsString()
    @Length(6, 8)
    @Matches(/^[a-zA-Z0-9]+$/, {
        message: 'OTP code must contain only alphanumeric characters',
    })
    code: string;
}
